var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.41669 6.37496V4.60413C1.41669 2.84038 2.84044 1.41663 4.60419 1.41663H6.37502",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 1.41663H12.3958C14.1596 1.41663 15.5833 2.84038 15.5833 4.60413V6.37496",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5833 11.3333V12.3958C15.5833 14.1596 14.1596 15.5833 12.3958 15.5833H11.3333",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37502 15.5833H4.60419C2.84044 15.5833 1.41669 14.1596 1.41669 12.3958V10.625",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43748 4.95837V6.37504C7.43748 7.08337 7.08331 7.43754 6.37498 7.43754H4.95831C4.24998 7.43754 3.89581 7.08337 3.89581 6.37504V4.95837C3.89581 4.25004 4.24998 3.89587 4.95831 3.89587H6.37498C7.08331 3.89587 7.43748 4.25004 7.43748 4.95837Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1042 4.95837V6.37504C13.1042 7.08337 12.75 7.43754 12.0417 7.43754H10.625C9.91667 7.43754 9.5625 7.08337 9.5625 6.37504V4.95837C9.5625 4.25004 9.91667 3.89587 10.625 3.89587H12.0417C12.75 3.89587 13.1042 4.25004 13.1042 4.95837Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43748 10.625V12.0417C7.43748 12.75 7.08331 13.1042 6.37498 13.1042H4.95831C4.24998 13.1042 3.89581 12.75 3.89581 12.0417V10.625C3.89581 9.91667 4.24998 9.5625 4.95831 9.5625H6.37498C7.08331 9.5625 7.43748 9.91667 7.43748 10.625Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1042 10.625V12.0417C13.1042 12.75 12.75 13.1042 12.0417 13.1042H10.625C9.91667 13.1042 9.5625 12.75 9.5625 12.0417V10.625C9.5625 9.91667 9.91667 9.5625 10.625 9.5625H12.0417C12.75 9.5625 13.1042 9.91667 13.1042 10.625Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.11667174c1ea9dc10ccecc4e962a7fc2.svg";
export { ForwardRef as ReactComponent };